import client from './client';

/**
 * 캠페인 관리현황
 */
export const campaignManageList = (params) =>
  client.get(`/api/report/campaign/list`, params);

/**
 * 캠페인 관리현황 - 이미지 리스트
 */
export const campaignManageImgList = (params) =>
  client.get(`/api/report/campaign/image`, { params: params });

/**
 * 캠페인 라이브현황
 */
export const campaignManageLive = (params) =>
  client.get(`/api/report/campaign/live`, params);

/**
 * 소재변경 캠페인관리
 */
export const changeList = (params) =>
  client.get(`/api/report/campaign/change`, params);

/**
 * 소재변경 캠페인관리 게재 상태 현황
 */
export const changeStateList = (params) =>
  client.get(`/api/report/campaign/change/cnt`, params);

/**
 * CTR2배 캠페인관리
 */
export const campaignCtrList = (params) =>
  client.get(`/api/report/campaign/ctr`, params);
